// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__merriweatherLightItalic_f30a22', '__merriweatherLightItalic_Fallback_f30a22', s, e, r, i, f","fontStyle":"normal"},"className":"__className_f30a22"};